import { TestContext } from './../types/test-context';
import { Injectable } from '@angular/core';
import { MapComponent } from '../components/map/map.component';
import { Decorable, Dict, VDict } from '../types/decorable';
import { AppContext } from '../types/app-context';
import { SLContext } from '../types/sl-context';
import { ButtonComponent } from '../components/button/button.component';


export type KeyComboTrigger = 'hold' | 'release' | 'press';
export type ActionHandler = (context: SLContext | TestContext, ...args: any) => void;
export type KeyCombo = {
  key: string;
  ctrl?: boolean;
  alt?: boolean;
  shift?: boolean;
  code?: string;

}
export type MappedAction = {
  name: string;
  handler: ActionHandler;
  keys?: KeyCombo;
  trigger?: KeyComboTrigger;
  src?: 'key';
}
export type ActionMap = VDict<MappedAction>;

export type MappedKey = {
  [key: string]: MappedAction;
};
export type KeyMap = {
  [key: string]: MappedAction;
}

@Injectable({
  providedIn: 'root'
})
export class ActionHandlerService {
  private actions: ActionMap = {};
  private context: SLContext | TestContext;
  private keyMap: KeyMap = {};
  private holdDuration = 2000;
  private buttonRegistry: {
    [key: string]: ButtonComponent
  } = {};
  private keyWatcher: Decorable = {
    lastKeyIndex: '',
    holding: false,
    start: null
  }
  private keyWatcherDefault: Decorable = {
    lastKeyIndex: '',
    holding: false,
    start: null
  }

  constructor() { }
  SetAppContext(context: SLContext | TestContext) {
    this.context = context;
  }
  MapActions(actionMap: ActionMap) {
    for (const action in actionMap) {
      if (actionMap.hasOwnProperty(action)) {
        const mappedAction: MappedAction = actionMap[action];
        const keyInfo: KeyCombo = mappedAction.keys;
        this.UpsertKey(keyInfo, mappedAction);
      }
    }
    this.actions = actionMap;
    console.log(this.keyMap);

  }
  GetComboIndexFromEvent(event: KeyboardEvent) {
    const keyCombo = {
      key: event.key.toLowerCase(),
      alt: event.altKey,
      shift: event.shiftKey,
      ctrl: event.ctrlKey,
      code: event.code
    }
    console.log(keyCombo);
    return this.GetComboIndex(keyCombo);
  }
  GetComboIndex(keyCombo): string {
    let key = '';
    if (keyCombo.ctrl) {
      key += 'CTRL_';
    }
    if (keyCombo.alt) {
      key += 'ALT_';
    }
    if (keyCombo.shift) {
      key += 'SHIFT_';
    }
    key += keyCombo.key.replace('+', 'plus');
    return key.toLowerCase();
  }
  UpsertKey(keyCombo: KeyCombo, action: MappedAction) {
    if (!action.keys) {
      return;
    }
    const index = this.GetComboIndex(keyCombo);
    if (!this.keyMap[index]) {
      this.keyMap[index] = action;
    }
  }
  GetKeyActionFromEvent(event: KeyboardEvent): MappedAction | null {
    const combo: KeyCombo = {
      key: event.key,
      code: event.code,
      alt: event.altKey,
      ctrl: event.ctrlKey,
      shift: event.shiftKey
    }
    const index = this.GetComboIndex(combo);
    console.log(index);
    if (!!this.keyMap[index]) { return this.keyMap[index]; }
    return null;

  }
  HandleAction(action: string, ...args: any): void {
    args.actionsSvc = this;
    if (!!this.actions) {
      if (!!this.actions[action]) {
        this.actions[action].handler(this.context, args as Dict);
      }
    }
  }
  SetupListeners(target: HTMLElement) {
    target.addEventListener('keyup', (event: KeyboardEvent) => {
      this.HandleKeyEvent(event);
    });
    target.addEventListener('keydown', (event: KeyboardEvent) => {
      this.HandleKeyEvent(event);
    });
  }
  HandleKeyEvent(event: KeyboardEvent) {
    const ignorable = ['textarea', 'input'].indexOf((event.target as HTMLElement).nodeName.toLowerCase()) > -1;
    if (ignorable === true) return;
    console.log("Event", event);
    const keyAction = this.GetKeyActionFromEvent(event);
    if (keyAction === null) {
      return;
    }
    event.preventDefault();
    event.stopImmediatePropagation();
    console.log(event);
    const keyIndex = this.GetComboIndexFromEvent(event);
    const end = new Date();
    const endTime = end.getTime();
    const start = this.keyWatcher.start;
    const startTime = (!!this.keyWatcher && this.keyWatcher.start) ? this.keyWatcher.start.getTime() : null;
    const delta = (!!startTime && !!endTime) ? endTime - startTime : 0;
    keyAction.src = "key";
    switch (event.type) {
      case 'keyup':
        if (this.keyWatcher.holding && this.keyWatcher.lastKeyIndex === keyIndex) {
          if (!this.keyWatcher.end) {
            if (delta > this.holdDuration) {
              this.keyWatcher.end = end;
              keyAction.handler(this.context, keyAction);
            }
          }
          return;
        }
        if (!!keyAction.trigger && keyAction.trigger === 'release') {
          keyAction.handler(this.context, keyAction);
          this.keyWatcher = Object.assign({}, this.keyWatcherDefault);
          return;
        }
        break;
      case 'keydown':
        this.keyWatcher.lastKeyIndex = keyIndex;
        this.keyWatcher.start = new Date();

        if (!!keyAction.trigger && !!event.repeat && keyAction.trigger === 'hold') {
          keyAction.handler(this.context, keyAction, delta / this.holdDuration);
        } else if (!!keyAction.trigger && keyAction.trigger === 'press') {
          keyAction.handler(this.context, keyAction);
        }
        break;
    }
  }
  GetKeyComboString(keys: KeyCombo) {
    if (!(!!keys && !!keys.key)) {
      return '';
    }
    let keyStroke = '(';
    if (!!keys.ctrl) {
      keyStroke += ' CTRL+';
    }
    if (!!keys.alt) {
      keyStroke += 'ALT+';
    }
    if (!!keys.shift) {
      keyStroke += 'SHIFT+';
    }
    keyStroke += keys.key.toUpperCase() + ' )';
    return keyStroke;
  }
  GetActionAlt(action: string): string {
    if (!!action && !!this.actions[action]) {
      const mappedAction: MappedAction = this.actions[action];
      let altString = mappedAction.name;
      if (!!mappedAction.keys) {
        const keyInfo = mappedAction.keys;
        const keyStroke = this.GetKeyComboString(keyInfo);
        altString += ' ' + keyStroke;
      }
      return altString;
    }
    return '';
  }
  RegisterNamedButton(button: ButtonComponent) {
    this.buttonRegistry[button.buttonName] = button;
  }
  GetNamedButton(buttonName: string): ButtonComponent | false {
    if (!!this.buttonRegistry[buttonName]) {
      return this.buttonRegistry[buttonName];
    }
    return false;
  }
  UnregisterNamedButton(buttonName: string) {
    const button = this.GetNamedButton(buttonName);
    if (button) {
      delete this.buttonRegistry[button.buttonName];
    }
  }
  UnRegisterNamedButton(button: ButtonComponent) {
    this.UnregisterNamedButton(button.buttonName);

  }

}
